import { z } from "zod";
import { Id, IsoDateTime, Page, PageQuery } from "./common";

export const DomainEventEntityType = z.enum([
  "Asset",
  "Device",
  "Integration",
  "Site",
]);
export type DomainEventEntityType = z.infer<typeof DomainEventEntityType>;

export const DomainEventType = z.enum([
  "Telemetry",
  "Diagnostic",
  "Location",
  "StateChanged",
  "IntegrationEvent",
  "Seed",
]);
export type DomainEventType = z.infer<typeof DomainEventType>;

export const DomainEvent = z.object({
  eventId: Id,
  tenantId: Id,
  entityType: DomainEventEntityType,
  entityId: Id,
  assetId: Id.nullable(),
  deviceId: Id.nullable(),
  integrationId: Id.nullable(),
  eventType: DomainEventType,
  occurredAt: IsoDateTime,
  payload: z.record(z.unknown()),
  createdAt: IsoDateTime,
});
export type DomainEvent = z.infer<typeof DomainEvent>;

export const DomainEventIngestInput = z.object({
  entityType: DomainEventEntityType,
  entityId: Id,
  assetId: Id.nullable().optional(),
  deviceId: Id.nullable().optional(),
  integrationId: Id.nullable().optional(),
  eventType: DomainEventType,
  occurredAt: IsoDateTime,
  payload: z.record(z.unknown()).default({}),
});
export type DomainEventIngestInput = z.infer<typeof DomainEventIngestInput>;

export const TelemetryEventPreview = z.object({
  eventId: Id,
  tenantId: Id,
  assetId: Id.nullable(),
  deviceId: Id.nullable(),
  eventType: DomainEventType,
  occurredAt: IsoDateTime,
  summary: z.string().max(500).nullable(),
  payload: z.record(z.unknown()),
});
export type TelemetryEventPreview = z.infer<typeof TelemetryEventPreview>;

export const DomainEventListFilters = PageQuery.extend({
  eventType: DomainEventType.optional(),
  occurredFrom: IsoDateTime.optional(),
  occurredTo: IsoDateTime.optional(),
});
export type DomainEventListFilters = z.infer<typeof DomainEventListFilters>;

export const DomainEventListResponse = Page(DomainEvent);
export type DomainEventListResponse = z.infer<typeof DomainEventListResponse>;

export const TelemetryEventPreviewListResponse = Page(TelemetryEventPreview);
export type TelemetryEventPreviewListResponse = z.infer<
  typeof TelemetryEventPreviewListResponse
>;
